import { RestUseCase, ServiceOperationResult } from 'service/api/rest/rest-usecase';

/**
 * Item do sino de notificacoes do fluxo de aprovacao. Espelha o NotificacaoPedidoDTO
 * da API: identificacao, pedido de origem, tipo do evento, mensagem em PT, flag de leitura,
 * data de criacao e o link (deep link) para o detalhe do pedido.
 */
export interface NotificacaoPedido {
  id: number;
  idPedido: number;
  tipoEvento: string;
  mensagem: string;
  lida: boolean;
  dataCriacao?: string;
  link?: string;
}

/**
 * Service do sino de notificacoes do fluxo. Consome os 3 endpoints do backend
 * (contador de nao-lidas, historico e marcar como lida). O destinatario e sempre o usuario
 * autenticado (resolvido no backend pelo token); o front nunca informa o id do destinatario.
 * Reaproveita RestUseCase, que normaliza a resposta em ServiceOperationResult.
 */
export class NotificacaoPedidoUseCase {
  constructor(private readonly baseEndpoint: string) {
    this.baseEndpoint = baseEndpoint;
  }

  /** Contador de nao-lidas do usuario logado, para o badge do sino. */
  async contarNaoLidas(): Promise<ServiceOperationResult<number>> {
    return new RestUseCase(`${this.baseEndpoint}/nao-lidas/contador`).Get_<number>();
  }

  /** Historico do usuario logado, da mais recente para a mais antiga. */
  async listar(): Promise<ServiceOperationResult<NotificacaoPedido[]>> {
    return new RestUseCase(this.baseEndpoint).Get_<NotificacaoPedido[]>();
  }

  /** Marca a notificacao (do proprio usuario) como lida e grava a data de leitura. */
  async marcarComoLida(id: number): Promise<ServiceOperationResult<NotificacaoPedido>> {
    return new RestUseCase(`${this.baseEndpoint}/${id}/marcar-lida`).Post_<NotificacaoPedido>({ data: {} });
  }
}
